import Vue from 'vue'
import App from './App.vue'
import router from './router'


/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios
import aes from './teras/aes'
Vue.prototype.$aes = aes
vueData.aes = aes

import './css/big.css'
/* Fine TerAs */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('checkAuth', async (from,to) =>{
  console.log("CHECK AUTH")
  if(storage.exist('utente')){
    console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI..."+to.path)
    teras.utente = storage.load('utente')
    teras.event.emit('login',to.path)
  }else{
    teras.check.auth = false
    teras.event.emit('errore',-1,'È necessario effettuare l\'accesso prima di poter accedere alla pagina')
    if(from.path!='/login')
      router.replace('/login')
  }
})
teras.event.on('appReady', function() {
  console.log("appReady appReady appReady appReady appReady appReady appReady")
  router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
/* Fine TerAs-event */
        

 

window.checkFirst =function(){
  return new Promise((resolve, reject) => {
    axios.query('fetchAll',`SELECT * FROM codicefiscale.comune WHERE 1 ORDER BY nome`,{},teras,'_comune')  
    axios.query('fetchAll',`SELECT * FROM codicefiscale.provincia WHERE id>0 AND id !=111 ORDER BY nome`,{},teras,'_provincia')  
    axios.query('fetchAll',`SELECT id,regione AS nome FROM codicefiscale.provincia WHERE regione!='' GROUP BY regione ORDER BY regione`,{},teras,'_regione')  
    axios.query('fetchAll',`SELECT * FROM bm_bvent.nazione WHERE 1 ORDER BY id`,{},teras,'_nazione')
    axios.query('fetchAll',`SELECT * FROM societa WHERE 1 ORDER BY peso,id`,{},teras,'_societa')
    //axios.query('fetchAll',`SELECT * FROM qualifica WHERE 1 ORDER BY id`,{},teras,'_qualifica')
    axios.query('fetchAll',`SELECT * FROM bm_limmsy_2018.tiposocio WHERE 1 ORDER BY id`,{},teras,'_tiposocio')
    teras.check.first = true
    resolve(true)
  })
}

/* Inizio TerAs-event-login */
teras.event.on('routerNoauth', function() {
})
teras.event.on('login', async (to) => {
  storage.save("utente",teras.utente)
  await socio.contatto.load(teras.utente.id)
  //console.error(socio.contatto.row)
  if(socio.contatto.row.codicefiscale==''){
    //this.$router.push('/contatto-edit')
    teras.app.routeInitial = 'contatto-edit' 
  }else{
    teras.app.routeInitial = 'home'  
  }    
  teras.check.auth = true
  console.log("APPREADY FROM LOGIN "+teras.app.routeInitial)
  router.replace(teras.app.routeInitial)
})

teras.event.on('logout', function() {
  teras.utente = {}
  storage.remove('utente')
  teras.check.auth = false
  router.replace('/login')
})
/* Fine TerAs-event-login */



import socio from './teras/socio'
Vue.prototype.$socio = socio
vueData.socio = socio



new Vue({

/* Inizio vue-class */
data:vueData,
/* Fine vue-class */
      
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
